import React, { ElementType, forwardRef, MutableRefObject } from 'react';
import classNames from 'classnames';
import styles from './ListRow.module.scss';

type ListRowWithRefProps = React.HTMLProps<any> & {
  selectable?: boolean;
  selected?: boolean;
  isInList?: boolean;
};

type ListRowProps<AsTypeProps> = Omit<React.HTMLProps<any>, 'as'> &
  AsTypeProps & {
    as?: ElementType;
    selectable?: boolean;
    selected?: boolean;
    isInList?: boolean;
  };

export function ListRowTitle({ className = null, children = null, ...props }) {
  className = classNames(className, styles.title, 'text-contact');

  return (
    <ListRowContent className={className} {...props}>
      {children}
    </ListRowContent>
  );
}

export function ListRowContent({
  className = null,
  children,
  fill = false,
  spaceless = false,
  ...props
}) {
  className = classNames(
    className,
    styles.content,
    fill ? styles.contentFill : null,
    spaceless && styles.spaceless,
  );
  return (
    <span className={className} {...props}>
      {children}
    </span>
  );
}

export function ListRow<AsTypeProps>({
  as: Component = 'div',
  selectable = false,
  selected = false,
  isInList = false,
  className = null,
  children,
  ...props
}: ListRowProps<AsTypeProps>) {
  className = classNames(
    styles.item,
    className,
    selectable ? styles.selectable : null,
    selected ? styles.selected : null,
    selected ? 'list-item-selected' : null,
    isInList && styles.list,
  );

  return (
    <Component className={className} {...props}>
      {children}
    </Component>
  );
}

export const ListRowWithRef = forwardRef(
  (
    {
      selectable = false,
      selected = false,
      isInList = false,
      className = null,
      children,
      ...props
    }: ListRowWithRefProps,
    ref: MutableRefObject<HTMLDivElement>,
  ) => {
    className = classNames(
      styles.item,
      className,
      selectable ? styles.selectable : null,
      selected ? styles.selected : null,
      selected ? 'list-item-selected' : null,
      isInList && styles.list,
    );

    return (
      <div className={className} {...props} ref={ref}>
        {children}
      </div>
    );
  },
);
